import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography, Divider } from '@material-ui/core';
import DeleteCancel from '../../atoms/buttons/DeleteCancel';
import errorConvertor from '../../../services/errorConvertor';
import { getConstructType } from '../../../config/common';
import { useParams } from 'react-router-dom';
import { useState, useEffect, Fragment } from 'react';
import { invokePostService, invokeGetService, setReRender, toggleBottomDrawer, setFocusElement } from "../../../store/global/actions";
import { handleSnackBar } from '../../../store/global/actions';
import { useHistory } from "react-router-dom";
import { getBottomDrawerStatus } from '../../../store/global/selectors';


export default function DeleteTransaction({ element, onClose, onCompletion, onDeleteConfirmation }) {
    const dispatch = useDispatch();
    const params = useParams();
    const history = useHistory();
    const currentUrl = window.location.href;
    const [slug, blueprintID, tag, transactionId] = currentUrl.split('/').slice(4);
    const selectedTransactionId = transactionId;
    const selectedTrans = element;
    const [isDeleting, setIsDeleting] = useState(false);
    const [parentTrans, setParentTrtans] = useState(null);
    const [isForceDelete, setIsForceDelete] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const bottomDrawerStatus = useSelector(getBottomDrawerStatus);

    useEffect(() => {
        
        if(element && element?.id && !isDeleting){
         
            dispatch(invokeGetService('getTransactionAssociates', [element.id]))
                .then((response) => {
                    if(response?.status){
                        if (response?.data?.transaction !== undefined) {
                            let parentTransaction = findParentObject(response?.data?.allTransaction, element.id);
                            if (parentTransaction !== undefined && parentTransaction != null) {
                                setParentTrtans(parentTransaction);
                            }
                        }
                    }else if(response?.code === 255 && response.transactionNotFound) {
                            dispatch(setFocusElement(null));
                            bottomDrawerStatus && dispatch(toggleBottomDrawer());
                            onClose();
                            history.push(`/blueprint/${slug}/${blueprintID}/system-model`);
                    } else {
                        console.error("Failed to fetch transaction details");
                    }
                
                }).catch(error => {
                    console.error('Fetching transactin details failed. ', error);
                })
   
        }
    }, [element]);

    const findParentObject = (arr, childId) => {
        for (const obj of arr) {
            if (obj.nestedTransactions && obj.nestedTransactions.length > 0) {
                const childFound = obj.nestedTransactions.find((child) => child.id === childId);
                if (childFound) {
                    return obj;
                }
            } else if (obj.invokedTransactions && obj.invokedTransactions.length > 0) {
                const childFound = obj.invokedTransactions.find((child) => child.id === childId);
                if (childFound) {
                    return obj;
                }
            }
        }
        return null; // No parent object found
    }

    const onDelete = () => {
        setIsDeleting(true);
        if (getConstructType(element.type) === 'nested_transaction') {
            if(onDeleteConfirmation) onDeleteConfirmation({id: element.id, type: "nested_transaction"} );
            const payload = { parentTransaction: element?.parent }
            dispatch(invokePostService('deleteNestedTransaction', payload, [element.id]))
                .then((response) => {
                    if (response.status && response.data) {
                        dispatch(setReRender());
                        onCompletion('Child transaction', 'delete')
                    }
                }).catch(error => {
                    console.error( `Nested transaction deletion failed. ${error}`);
                })
        }else if (selectedTransactionId !== element.id && getConstructType(element.type) === 'transaction') {
            if(onDeleteConfirmation) onDeleteConfirmation({id: element?.uuid, type: "invoked_transaction"} );
            
            const payload = { invokedId: element.id, uuid: element?.uuid, parentTransactionId: element?.parent };
            dispatch(invokePostService('deleteInvokedTransaction', payload, [params.transaction]))
                .then((response) => {
                    if (response.status && response.data) {
                        dispatch(setReRender());
                        onCompletion('Invoked transaction', 'delete')
                    }

                })
        }else if (selectedTransactionId === element.id && getConstructType(element.type) === 'transaction') {
            dispatch(setFocusElement(null));
            bottomDrawerStatus && dispatch(toggleBottomDrawer());

            dispatch(invokePostService('deleteTransaction', {isForceDelete}, [transactionId]))
                .then((response) => {
                    if (response.status) {
                        onCompletion("Transaction", "delete");
                        if (response?.data != null) {
                            history.push(`/blueprint/${slug}/${blueprintID}/transaction/${response?.data?._id}`);
                        }else {
                            history.push(`/blueprint/${slug}/${blueprintID}/system-model`);
                        }
                    } else if (response?.data?.validationErrors?.length > 0) {
                        setIsForceDelete(true);
                        const converter = new errorConvertor(response?.data?.validationErrors)
                        converter.customConvert('The [item] is used in [feature] [featureEntity]');
                        setValidationErrors([...converter.sentences]);
                    }else if (response?.status === false && response?.code) {
                        onCompletion();
                        history.push(`/blueprint/${slug}/${blueprintID}/system-model`);
                    }else {
                        dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
                    }
                    
                    dispatch(setReRender());
                    setIsDeleting(false)

                }).catch(error => {
                    console.error(`Delete tranaction ${transactionId} failed. ${error} `);
                    dispatch(handleSnackBar({ open: true, message: "Delete transaction failed. ", severity: "error" }));
                })


        }else{
            console.error("Cannot identify transaction type to delete !!!!!!!!!!!!!!!")
        }
    }


    return (
        <Grid container direction={"row"} spacing={1} >

            <Grid item xs={12}>
                <Typography variant="h6" >Delete</Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12}>
                <Typography> Are you sure you want to delete the Transaction {selectedTrans.name} ? </Typography>
                {validationErrors.length > 0 && (
                        <Fragment>
                            <br />
                            <ol id="validationErrors">
                                {validationErrors.map((item, index) => {
                                    const words = item.error.split(' '); 
                                    const lastWord = words.pop(); 
                                    const restOfText = words.join(' '); 
                                    const boldStyle = { fontWeight: 'bold' };

                                    return (
                                        <li key={index}>
                                            {restOfText}{' '}
                                            <span style={{fontWeight: 'bold'}}>{lastWord}</span>
                                        </li>
                                    );
                                })}
                            </ol>
                        </Fragment>
                    )}

            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <DeleteCancel onDelete={onDelete} onCancel={onClose} disableButton={isDeleting} content={isDeleting ? 'Deleting..' : isForceDelete ? 'Delete Anyway' : 'Delete'} />
            </Grid>


        </Grid>
    )
}

